
import { fetcher, endpoints, poster } from '../utils/axios';

/**
 * @function addAdminAndCompanyUsers
 * @description Adds a new admin and company user to the database.
 * @param {Object} payload - The object containing the admin and company user's information.
 * @returns {Promise} - A promise that resolves or rejects based on the response from the server.
 */
export async function addAdminAndCompanyUsers(payload) {
    const URL = endpoints.admin.addAdminAndCompanyUsers;
    return await poster([URL, payload])
}

/**
 * @function getAllAdminsAndCompanies
 * @description Retrieves a list of all admin and company users in the database.
 * @param {Object} payload - The object containing the query parameters for the request.
 * @returns {Promise} - A promise that resolves or rejects based on the response from the server.
 */
export async function getAllAdminsAndCompanies(payload) {
    const URL = endpoints.admin.getAllAdminsAndCompanies;
    return await fetcher([URL, {params:payload}])
}

/**
 * @function deleteUser
 * @description Deletes a user from the database.
 * @param {Object} payload - The object containing the user's ID to delete.
 * @returns {Promise} - A promise that resolves or rejects based on the response from the server.
 */
export async function deleteUser(payload) {
    const URL = endpoints.admin.deleteUser;
    return await poster([URL, payload])
}

/**
 * @function deleteWorkHistory
 * @description Deletes a work history from the database.
 * @param {Object} payload - The object containing the work history ID to delete.
 * @returns {Promise} - A promise that resolves or rejects based on the response from the server.
 */
export async function deleteWorkHistory(payload) {
    const URL = endpoints.admin.deleteWorkHistory;
    return await poster([URL, payload])
}
  